export default {
    metrika: {
        id: 26812653
    },

    defaults: {
        hooks: {
            onready: function () {},
            onshare: function () {},
            onClosePopup: function () {}
        },

        theme: {
            bare: false,
            curtain: false,
            // Ð”Ð¾Ñ€Ð°Ð±Ð¾Ñ‚ÐºÐ° Ð´Ð»Ñ Ð¿Ñ€ÐµÐ²ÑŒÑŽ Ð² ÐšÐ¾Ð½ÑÑ‚Ñ€ÑƒÐºÑ‚Ð¾Ñ€Ðµ Ð›ÐµÐ½Ð´Ð¸Ð½Ð³Ð¾Ð² https://st.yandex-team.ru/SHARE-564#5ef47c5cb93c9f4dc7e064c3
            forceCurtain: false,
            copy: 'last',
            lang: 'ru',
            limit: false,
            nonce: '',
            moreButtonType: '',
            popupPosition: 'inner',
            popupDirection: 'bottom',
            colorScheme: 'normal',
            shape: 'normal',
            services: 'vkontakte,twitter',
            messengerContacts: false,
            size: 'm',
            useLinks: false,
            direction: 'horizontal'
        },

        i18n: {
            az: {
                shareButton: 'PaylaÅŸmaq',
                copyLink: 'ÆlaqÉ™',
                linkCopied: 'KeÃ§id kÃ¶Ã§Ã¼rÃ¼ldÃ¼',
                otherServices: 'DigÉ™r',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'Yandex.MessencerÉ™ gÃ¶ndÉ™rmÉ™k'
            },
            be: {
                shareButton: 'ÐŸÐ°Ð´Ð·ÑÐ»Ñ–Ñ†Ñ†Ð°',
                copyLink: 'CÐ¿Ð°ÑÑ‹Ð»ÐºÐ°',
                linkCopied: 'Ð¡Ð¿Ð°ÑÑ‹Ð»ÐºÐ° ÑÐºÐ°Ð¿Ñ–ÑÐ²Ð°Ð½Ð°',
                otherServices: 'Ð†Ð½ÑˆÑ‹Ñ',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'ÐÐ´Ð¿Ñ€Ð°Ð²Ñ–Ñ†ÑŒ Ñƒ Ð¯Ð½Ð´ÐµÐºÑ.ÐœÑÑÑÐ½Ð´Ð¶Ð°Ñ€'
            },
            en: {
                shareButton: 'Share',
                copyLink: 'Copy link',
                linkCopied: 'Link copied',
                otherServices: 'Other',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'Send to Yandex.Messenger'
            },
            hy: {
                shareButton: 'Ô¿Õ«Õ½Õ¾Õ¥Õ¬',
                copyLink: 'Õ€Õ²Õ¸Ö‚Õ´',
                linkCopied: 'Õ€Õ²Õ¸Ö‚Õ´Õ¨ ÕºÕ¡Õ¿Õ³Õ¥Õ¶Õ¾Õ¥Õ¬ Õ§',
                otherServices: 'Ô±ÕµÕ¬',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'ÕˆÖ‚Õ²Õ¡Ö€Õ¯Õ¥Õ¬ Yandex.Messenger-Õ«Õ¶'
            },
            ka: {
                shareButton: 'áƒ’áƒáƒ–áƒ˜áƒáƒ áƒ”áƒ‘áƒ',
                copyLink: 'áƒ‘áƒ›áƒ£áƒšáƒ˜',
                linkCopied: 'á²‘áƒ›áƒ£áƒšáƒ˜ áƒ“áƒáƒ™áƒáƒžáƒ˜áƒ áƒ”áƒ‘áƒ£áƒšáƒ˜áƒ',
                otherServices: 'áƒ¡áƒ®áƒ•áƒ',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'Yandex.Messenger-áƒ¨áƒ˜ áƒ’áƒáƒ’áƒ–áƒáƒ•áƒœáƒ'
            },
            kk: {
                shareButton: 'Ð‘Ó©Ð»Ñ–ÑÑƒ',
                copyLink: 'Ð¡Ñ–Ð»Ñ‚ÐµÐ¼Ðµ',
                linkCopied: 'Ð¡Ñ–Ð»Ñ‚ÐµÐ¼Ðµ ÐºÓ©ÑˆÑ–Ñ€Ñ–Ð»Ð´Ñ–',
                otherServices: 'Ð‘Ð°ÑÒ›Ð°',
                pressToCopy: 'ÐšÓ©ÑˆÑ–Ñ€Ñƒ Ò¯ÑˆÑ–Ð½ ctrl+Ð¡ Ð¶Ó™Ð½Ðµ enter-Ð´Ñ‹ Ð±Ð°ÑÑ‹Ò£Ñ‹Ð·',
                sendToMessenger: 'Ð¯Ð½Ð´ÐµÐºÑ.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€Ð³Ðµ Ð¶Ñ–Ð±ÐµÑ€Ñƒ'
            },
            ro: {
                shareButton: 'Distribuie',
                copyLink: 'Link',
                linkCopied: 'Link copiat',
                otherServices: 'Altele',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                // https://st.yandex-team.ru/TRANSLATEADMIN-3335
                sendToMessenger: 'Send to Yandex.Messenger'
            },
            ru: {
                shareButton: 'ÐŸÐ¾Ð´ÐµÐ»Ð¸Ñ‚ÑŒÑÑ',
                copyLink: 'Ð¡ÐºÐ¾Ð¿Ð¸Ñ€Ð¾Ð²Ð°Ñ‚ÑŒ ÑÑÑ‹Ð»ÐºÑƒ',
                linkCopied: 'Ð¡ÑÑ‹Ð»ÐºÐ° ÑÐºÐ¾Ð¿Ð¸Ñ€Ð¾Ð²Ð°Ð½Ð°',
                otherServices: 'Ð”Ñ€ÑƒÐ³Ð¸Ðµ',
                pressToCopy: 'Ð§Ñ‚Ð¾Ð±Ñ‹ ÑÐºÐ¾Ð¿Ð¸Ñ€Ð¾Ð²Ð°Ñ‚ÑŒ, Ð½Ð°Ð¶Ð¼Ð¸Ñ‚Ðµ ctrl+Ð¡ Ð¸ enter',
                sendToMessenger: 'ÐžÑ‚Ð¿Ñ€Ð°Ð²Ð¸Ñ‚ÑŒ Ð² Ð¯Ð½Ð´ÐµÐºÑ.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€'
            },
            tr: {
                shareButton: 'PaylaÅŸ',
                copyLink: 'BaÄŸlantÄ±',
                linkCopied: 'BaÄŸlantÄ± kopyalandÄ±',
                otherServices: 'DiÄŸer',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'Yandex.Messenger\'a gÃ¶nder'
            },
            tt: {
                shareButton: 'Ð£Ñ€Ñ‚Ð°ÐºÐ»Ð°ÑˆÑƒ',
                copyLink: 'Ð¡Ñ‹Ð»Ñ‚Ð°Ð¼Ð°',
                linkCopied: 'Ð¡Ñ‹Ð»Ñ‚Ð°Ð¼Ð° ÐºÒ¯Ñ‡ÐµÑ€ÐµÐ¿ Ð°Ð»Ñ‹Ð½Ð´Ñ‹',
                otherServices: 'Ð‘Ð°ÑˆÐºÐ°Ð»Ð°Ñ€',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'Ð¯Ð½Ð´ÐµÐºÑ.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€Ð³Ð° Ò—Ð¸Ð±Ó™Ñ€Ò¯'
            },
            uk: {
                shareButton: 'ÐŸÐ¾Ð´Ñ–Ð»Ð¸Ñ‚Ð¸ÑÑ',
                copyLink: 'ÐŸÐ¾ÑÐ¸Ð»Ð°Ð½Ð½Ñ',
                linkCopied: 'ÐŸÐ¾ÑÐ¸Ð»Ð°Ð½Ð½Ñ ÑÐºÐ¾Ð¿Ñ–Ð¹Ð¾Ð²Ð°Ð½Ð¾',
                otherServices: 'Ð†Ð½ÑˆÑ–',
                pressToCopy: 'Press ctrl+C and Enter to copy',
                sendToMessenger: 'ÐÐ°Ð´Ñ–ÑÐ»Ð°Ñ‚Ð¸ Ð² Ð¯Ð½Ð´ÐµÐºÑ.ÐœÐµÑÐµÐ½Ð´Ð¶ÐµÑ€'
            },
            uz: {
                shareButton: 'Ulashish',
                copyLink: 'Havoladan nusxa olish',
                linkCopied: 'Havola nusxalandi',
                otherServices: 'Boshqalar',
                pressToCopy: 'Nusxa olish uchun ctrl+Ð¡ va enter tugmalarini bosing',
                sendToMessenger: 'Yandex.Messengerga yuborish'
            }
        },

        content: {
            template: 'default',
            description: '',
            image: '',
            title: window.document.title,
            url: window.location.href
        },

        contentByService: {},

        asPopup: false
    }
};
